import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d6na8114a3uojp5fh2ug', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#0F1419] text-white rounded-t-[40px] mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Üst Kısım */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Newsletter */}
          <div>
            <h3 className="text-3xl font-light mb-1">Kampanyalardan</h3>
            <h3 className="text-3xl font-light mb-4">Haberdar Olun</h3>
            <p className="text-sm text-gray-400 mb-6">
              Özel fırsatları ve profesyonel etiket baskı kampanyalarını kaçırmayın
            </p>
            <form id="newsletter-form" data-readdy-form onSubmit={handleNewsletterSubmit} className="space-y-3">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="E-posta adresiniz"
                className="w-full bg-transparent border-b border-gray-600 py-3 text-sm focus:outline-none focus:border-[#FF6B35] transition-colors"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-3 bg-white text-black text-sm font-semibold rounded-full hover:bg-gray-100 transition-all disabled:opacity-50 whitespace-nowrap flex items-center justify-center gap-2"
              >
                {isSubmitting ? 'Gönderiliyor...' : 'Abone Ol'}
                <i className="ri-arrow-right-line"></i>
              </button>
              {submitStatus === 'success' && (
                <p className="text-xs text-green-400">Başarıyla abone oldunuz!</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-xs text-red-400">Bir hata oluştu, tekrar deneyin.</p>
              )}
            </form>
          </div>

          {/* Hızlı Linkler */}
          <div>
            <h4 className="text-base font-semibold text-[#FF6B35] mb-6">Hızlı Erişim</h4>
            <ul className="space-y-3">
              <li>
                <a href="/#services" className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">
                  Hizmetlerimiz
                </a>
              </li>
              <li>
                <a href="/#product-types" className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">
                  Ürün Kataloğu
                </a>
              </li>
              <li>
                <a href="/#testimonials" className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">
                  Referanslar
                </a>
              </li>
              <li>
                <a href="/#portfolio" className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">
                  Portföy
                </a>
              </li>
              <li>
                <Link to="/blog" className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">
                  Blog & Rehber
                </Link>
              </li>
              <li>
                <a href="/#contact" className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">
                  İletişim
                </a>
              </li>
            </ul>
          </div>

          {/* Blog Yazıları */}
          <div>
            <h4 className="text-base font-semibold text-[#FF6B35] mb-6">Popüler Makaleler</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/blog/etiket-malzeme-secimi" className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer leading-snug block">
                  Etiket Malzeme Seçimi Rehberi
                </Link>
              </li>
              <li>
                <Link to="/blog/dijital-vs-flekso-baski" className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer leading-snug block">
                  Dijital vs Flekso Baskı
                </Link>
              </li>
              <li>
                <Link to="/blog/gida-etiketi-zorunlu-bilgiler" className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer leading-snug block">
                  Gıda Etiketi Zorunlu Bilgiler
                </Link>
              </li>
              <li>
                <Link to="/blog/kozmetik-etiket-baskisi-bioetiket" className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer leading-snug block">
                  Kozmetik Etiket Baskısı
                </Link>
              </li>
              <li>
                <Link to="/blog/umraniye-etiket-basim-hizmetleri" className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer leading-snug block">
                  Ümraniye Etiket Baskı
                </Link>
              </li>
              <li>
                <Link to="/blog/atasehir-isletmeleri-etiket-cozumleri" className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer leading-snug block">
                  Ataşehir Etiket Çözümleri
                </Link>
              </li>
              <li>
                <Link to="/blog/yukari-dudullu-etiket-baski" className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer leading-snug block">
                  Yukarı Dudullu Etiket Baskı
                </Link>
              </li>
            </ul>
          </div>

          {/* İletişim */}
          <div>
            <h4 className="text-base font-semibold text-[#FF6B35] mb-6">İletişim</h4>
            <div className="space-y-4">
              <div className="space-y-1">
                <a href="tel:+902163658878" className="block text-sm text-gray-400 hover:text-[#FF6B35] transition-colors">
                  +90 216 365 88 78 <span className="text-gray-600">(Sabit)</span>
                </a>
                <a href="tel:+905326018294" className="block text-sm text-gray-400 hover:text-[#FF6B35] transition-colors">
                  +90 532 601 82 94 <span className="text-gray-600">(Mobil)</span>
                </a>
                <a href="tel:+905370207788" className="block text-sm text-gray-400 hover:text-[#FF6B35] transition-colors">
                  +90 537 020 77 88 <span className="text-gray-600">(Satış)</span>
                </a>
              </div>
              <div className="space-y-1">
                <a href="mailto:info@bioetiket.com" className="block text-sm text-gray-400 hover:text-[#FF6B35] transition-colors">
                  info@bioetiket.com
                </a>
                <a href="mailto:teklif@bioetiket.com" className="block text-sm text-gray-400 hover:text-[#FF6B35] transition-colors">
                  teklif@bioetiket.com
                </a>
              </div>
              <div>
                <h5 className="text-sm font-semibold mb-1 text-gray-300">Adres</h5>
                <a
                  href="https://maps.google.com/?q=Yukarı+Dudullu+Mah.+Necip+Fazıl+Blv.+No:70+Ümraniye+İstanbul"
                  target="_blank"
                  rel="nofollow"
                  className="text-sm text-gray-400 hover:text-[#FF6B35] transition-colors leading-relaxed cursor-pointer"
                >
                  Yukarı Dudullu Mah. Necip Fazıl Blv.<br />
                  No: 70, Ümraniye / İstanbul
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Alt Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            {/* Sosyal Medya */}
            <div className="flex gap-6">
              <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>

            {/* Copyright */}
            <div className="text-sm text-gray-400 text-center">
              © 2025 Bioetiket. Tüm hakları saklıdır.
            </div>

            {/* Linkler */}
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">
                Gizlilik Politikası
              </a>
              <a href="#" className="text-gray-400 hover:text-[#FF6B35] transition-colors cursor-pointer">
                Kullanım Şartları
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}